(function () {

    function animateBar(bar) {
        const target = bar.dataset.width || '0';
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                bar.style.width = target + '%';
            });
        });
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            animateBar(el);
            observer.unobserve(el);
        });
    }, { threshold: 0.3 });

    document.querySelectorAll('.bar-fill').forEach(function (el) {
        observer.observe(el);
    });

})();